import Flex from 'src/styles/layouts/Flex';
import styled from 'styled-components';

export const FlexEx = styled(Flex)`
	border-left: 2px solid #393b3b;
`;
